import { SectionType } from '../enums/section-type.enum';
import { ISectionQuery } from '../interfaces/section.query.interface';
import { Section } from './section.model';

export class OneFileSection extends Section {
    constructor(query?: ISectionQuery) {
        super(query);

        this._type = SectionType.OneFile;
    }
}
